module.exports = __webpack_public_path__ + "img/FREED FROM DESIGNER LIGHT.ec8d2119.png";